import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';

const element = document.querySelector('div.smartplayer-component.smartplayer--iframe') as HTMLElement;

const root = ReactDOM.createRoot(element);

root.render(
  <App code={(element?.dataset?.code || '').toString()} newPlayer={element?.dataset?.newplayer === '1'} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
